export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 pt-12 pb-6">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-4 gap-8">

        {/* BRAND */}
        <div>
          <h2 className="text-xl font-bold text-white mb-3">
            Venkata Sai Traders
          </h2>
          <p className="text-sm">
            Delivering premium agro commodities across global markets with trust,
            quality, and reliability.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div>
          <h3 className="text-white font-semibold mb-3">
            Quick Links
          </h3>
          <ul className="space-y-2 text-sm">
            <li><a href="#hero" className="hover:text-green-400">Home</a></li>
            <li><a href="#products" className="hover:text-green-400">Products</a></li>
            <li><a href="#about" className="hover:text-green-400">About</a></li>
            <li><a href="#contact" className="hover:text-green-400">Contact</a></li>
          </ul>
        </div>

        {/* PRODUCTS */}
        <div>
          <h3 className="text-white font-semibold mb-3">
            Products
          </h3>
          <ul className="space-y-2 text-sm">
            <li>Basmati Rice</li>
            <li>Ponni Rice</li>
            <li>Spices</li>
            <li>Pulses</li>
          </ul>
        </div>

        {/* CONTACT */}
        <div>
          <h3 className="text-white font-semibold mb-3">
            Contact
          </h3>
          <ul className="space-y-2 text-sm">
            <li>📍 Tamil Nadu, India</li>
            <li>📞 +91 9884204949</li>
            <li>✉️ info@venkatasaitraders.com</li>
          </ul>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="border-t border-gray-700 mt-8 pt-4 text-center text-sm text-gray-500">
        ©  2022 Venkata Sai Traders. All rights reserved.
      </div>
    </footer>
  );
}